import {
    Component,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
    OnDestroy,
    AfterContentChecked
} from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import * as moment from "moment";
import {
    FancyImageUploaderComponent,
    FancyImageUploaderOptions,
    Status
} from "ng2-fancy-image-uploader";
import { TranslateService } from "ng2-translate/ng2-translate";
import { Subject, Observable, Subscription } from "rxjs/Rx";
import { Identificationtype } from "../../models/User/documentupload/user.documentupload.model";
import {
    enumEventype,
    UserProfileTMNIovation
} from "../../models/user/user.tm.profile.model";
import { AlertService } from "../../sharedcomponents/commonservice/alert.service";
import { CountryService } from "../../sharedcomponents/commonservice/countrylist.service";
import { occupationoppservice } from "../../sharedcomponents/commonservice/occupation/ocupation.service";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import {
    AppSettings,
    enumStatusCodeList
} from "../../sharedcomponents/_common/constants/app.constants";
import { CountryDetail } from "../../sharedcomponents/_common/countrylist/countryinformation";
// import { OccupationModal } from '../../sharedcomponents/commonservice/occupation/Occupation/Occupation.Modal';
import { state } from "../../sharedcomponents/_common/countrylist/state";
import { ErrorPopupComponent } from "../../sharedcomponents/_directive/error-popup/error-popup.component";
import { ResetPasswordEditProfileComponent } from "../../user/reset-password/reset-password.EditProfile.component"; //Edit USer reset password
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { AuthService } from "../../_services/userservice/auth.service";
import { usercommonattribute } from "../../_services/userservice/user.common.service";
import { userdocserviceopp } from "../../_services/userservice/user.documentupload.service";
//Service Section
import { UserService } from "../../_services/userservice/user.service";
import { UserStateService } from "../../_services/userservice/userstateservice";
import { LoyaltyLoginComponent } from "../loyalty-login/loyalty-login.component-Step1";
import { uploaddocumtuserprofilestep1 } from "../user-register/user-document-upload/userprofile-document-upload.component-Step1";
import { uploaddocumtuserprofilestep2 } from "./user-document-upload/userprofile-document-upload.component-Step2";
import { EditProfileMobileOTPComponent } from "./user-editprofile-mobileOTPVerification/user-editProfileMobileOTPVerification";
import { StatelistComponent } from "../../sharedcomponents/_common/countrylist/statelist.component";
import { CitylistComponent } from "../../sharedcomponents/_common/countrylist/citylist.component";
import { GoogleAutocompleteComponent } from "../../sharedcomponents/_common/countrylist/google-autocomplete/google-autocomplete.component";
import { loyaltylogin } from "../../_services/userservice/user.loyaltylogin.service";
import { AlertPopupComponent } from "app/sharedcomponents/_directive/alert-popup/alert-popup.component";
import { countrylist } from "app/sharedcomponents/_common/countrylist/countrylist.component";

import { ThreatMetrixService } from '../../_services/ThreatMetrix/threatmetrix'

declare var $: any;
@Component({
    moduleId: module.id,
    styleUrls: ["./user-editprofile.css"],
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./user-editprofile.component.html",
    providers: [
        UserService,
        AlertService,
        Modal,
        CountryService,
        AuthService,
        occupationoppservice,
        userdocserviceopp,
        ThreatMetrixService
    ]
})
export class UserEditProfileComponent
    implements OnInit, AfterContentChecked, OnDestroy {
    @ViewChild(FancyImageUploaderComponent)
    profileimageUploader: FancyImageUploaderComponent;
    @ViewChild("f") formObj: any;

    profileimageData: any = {};
    //  model: User ;
    userProfileTMNIovation: UserProfileTMNIovation;
    OccupationNameObj: any;
    public searchurl = AppSettings.ICEMasterService;
    formReadOnly = false;
    mobilePre = "0";
    loading = false;
    x2js: any;
    countryinfo: CountryDetail;
    countrycollection = []; //new Array<CountryDetail>();
    preferCountrycollection = [];
    ocupencycollection: any = [];
    // results: any[];
    finalOccuppeancyresults = [];
    stateCollection: Array<state> = [];
    cityCollection: any = [];
    defaultCountry: CountryDetail;
    filterstates: any;
    filterCities: any;
    url: any;
    public query = "";
    documentList: any = [];
    docUploadinfo: any;
    appSettings: any = {};
    public defaultDate: any;
    yearRange = "";
    isDocumentRequired = false;
    existingMobileNumber;
    taxMaskPattern = [];
    taxMaskPlaceHolder = "";
    existinSSNNumber = "";
    saveDocModel: any = {};
    DocumentRequired: {};
    editProfileTabImage = "./assets/images/p_icon.png";
    editProfileDocumentTabImage = "./assets/images/doc_icon.png";
    options: FancyImageUploaderOptions = {
        thumbnailHeight: 150,
        thumbnailWidth: 150,
        uploadUrl: null,
        allowedImageTypes: ["image/png", "image/jpeg"],
        maxImageSize: 15,
        autoUpload: false
    };
    private subProfile = new Subject<boolean>();
    private loyallogUnsub: Subscription;
    busy: Subscription;
    fraudDetectionPromise: Promise<any>;

    @Output()
    subProfileObservable = this.subProfile.asObservable();

    addressSettings: any = {};
    constructor(
        private sendMoneyService: SendMoneyService,
        private translate: TranslateService,
        private userService: UserService,
        private alertService: AlertService,
        public modal: Modal,
        private countryserv: CountryService,
        public utilserv: utilityService,
        public model: usercommonattribute,
        private auth: AuthService,
        private occupency: occupationoppservice,
        private userdoc: userdocserviceopp,
        private loyallog: loyaltylogin,
        private vcRef: ViewContainerRef,
        private userStateService: UserStateService,
        private router: Router,
        private threatMetrixService: ThreatMetrixService
    ) {
        this.translate.use(sessionStorage.langCode).subscribe(data => {
            // this.addressSettings = {
            //   showSearchButton: false,
            //   geoCountryRestriction: ['us'],
            //   inputPlaceholderText: this.translate.instant('Common_lblSearchFromGoogle'),
            //   geoTypes: ['establishment', 'address', 'geocode']
            // };

            this.appSettings = AppSettings;

            this.model.mobilePrefix = 1;
            this.userDetails();

        });
    }

    setUserDetails(data) {

        console.log("setuserdetail");
        if (this.utilserv.getObjectText(data.UserID) != "") {
            this.model.UserID = this.utilserv.getObjectText(data.UserID);
        }
        if (this.utilserv.getObjectText(data.FirstName) != "") {
            this.model.firstName = this.utilserv.getObjectText(data.FirstName);
        }
        if (this.utilserv.getObjectText(data.MiddleName) != "") {
            this.model.middleName = this.utilserv.getObjectText(data.MiddleName);
        }
        if (this.utilserv.getObjectText(data.LastName) != "") {
            this.model.lastName = this.utilserv.getObjectText(data.LastName);
        }
        if (this.utilserv.getObjectText(data.AdditionalLastName) != "") {
            this.model.additionalLastName = this.utilserv.getObjectText(
                data.AdditionalLastName
            );
        }
        if (this.utilserv.getObjectText(data.DOB) != "") {
            this.model.dob = this.utilserv.getObjectText(data.DOB);
        }
        // if (this.utilserv.getObjectText(data.CustomerEmail) != '') {
        //   this.model.email = this.utilserv.getObjectText(data.CustomerEmail);
        // } // cant change user email while doing loyalty scan
        // if (this.utilserv.getObjectText(data.MobileNumber) != '') {
        //   this.model.mobile = this.utilserv.getObjectText(data.MobileNumber);
        // } // cant change user mobile while doing loyalty scan

        if (this.utilserv.getObjectText(data.PreferCountryCode) != "") {
            this.model.countryPreference = this.utilserv.getObjectText(
                data.PreferCountryCode
            );
        }

        if (this.utilserv.getObjectText(data.CountryCode) != "") {
            this.model.country = this.utilserv.getObjectText(
                data.Address.CountryCode
            );
        }
        if (this.utilserv.getObjectText(data.Address.StateCode) != "") {
            this.model.state = this.utilserv.getObjectText(data.Address.StateCode);
        }
        if (this.utilserv.getObjectText(data.Address.CityCode) != "") {
            this.model.city = this.utilserv.getObjectText(data.Address.CityCode);
        }
        if (this.utilserv.getObjectText(data.Address.ZipCode) != "") {
            this.model.zipcode = this.utilserv.getObjectText(data.Address.ZipCode);
        }
        if (this.utilserv.getObjectText(data.Address.Address1) != "") {
            this.model.address = this.utilserv.getObjectText(data.Address.Address1);
        }
        if (this.utilserv.getObjectText(data.CustomerOccupation) != "") {
            this.model.occupation = this.utilserv.getObjectText(
                data.CustomerOccupation
            );
        }
        if (this.utilserv.getObjectText(data.CustomerEmployer) != "") {
            this.model.employess = this.utilserv.getObjectText(data.CustomerEmployer);
        }
        if (this.utilserv.getObjectText(data.UserProfileImage) != "") {
            this.model.UserProfileImage = this.utilserv.getObjectText(
                data.UserProfileImage
            );
        }
        if (this.utilserv.getObjectText(data.IsBeingLinked) != "") {
            this.model.IsBeingLinked = this.utilserv.getObjectText(
                data.IsBeingLinked
            );
        }
        if (this.utilserv.getObjectText(data.LoyaltyCardNumber) != "") {
            this.model.loyaltyCardNumber = this.utilserv.getObjectText(
                data.LoyaltyCardNumber
            );
        }
        if (this.utilserv.getObjectText(data.LastOrderNumber) != "") {
            this.model.LastOrderNumber = this.utilserv.getObjectText(
                data.LastOrderNumber
            );
        }
        if (this.utilserv.getObjectText(data.MaxTransferAmountLimit) != "") {
            this.model.maxTransferAmountLimit = this.utilserv.getObjectText(
                data.MaxTransferAmountLimit
            );
        }

        // share credit
        this.model.MarketingBalance =
            this.utilserv.getObjectText(data.MarketingBalance) == ""
                ? 0
                : this.utilserv.getObjectText(data.MarketingBalance);
        // Not Required now

        if (this.utilserv.getObjectText(data.UserProfileImage) != "") {


            this.model.userimageurl = this.utilserv.getObjectText(
                data.UserProfileImage
            );
        }
        if (this.utilserv.getObjectText(data.TaxID) != "") {
            this.model.taxID = this.utilserv.getObjectText(data.TaxID);
        }
    }

    initialzecollection() {

        let self = this;

        self.countrycollection = self.countryserv.getCountryListFromLocale();

        if (!self.model.country) {
            self.model.country = AppSettings.BaseCountry;
        }

        self.setOccupation();
        self.returnTaxMask();


        let coll = self.countrycollection.filter(function (country) {
            return country.CountryCode === self.model.country;
        });

        if (coll.length > 0) {
            self.stateCollection = coll[0].CountryState;
        }
    }

    userDetails() {

        this.utilserv.busy = this.auth.getUserDetail().subscribe(
            data => {
                const resJSON = data;
                if (
                    resJSON.Envelope.Body.CustomerInfoResponse.StatusCode ==
                    enumStatusCodeList.SUCCESS
                ) {
                    this.model = this.auth.setUserDetails(resJSON);
                    sessionStorage.UserData = this.utilserv.AESEncrypt(
                        JSON.stringify(resJSON)
                    );
                    this.initialzecollection();
                    if (this.model.IsBeingLinked == "true") {
                        this.isdocumentRequiredCheck();
                    }

                    // this.url = this.model.userimageurl;

                    this.loadDocImage(this.model.userimageurl.replace(/\s/g, ""));
                    this.existingMobileNumber = this.model.mobile;
                    this.existinSSNNumber = this.model.taxID;
                    this.model.country = AppSettings.BaseCountry;
                    let userdata: any = {};
                    this.model.UserVerifiedBy = "";
                    this.loyallogUnsub = this.loyallog
                        .getEditUserData()
                        .subscribe(data => {
                            if (data == null) {
                                return false;
                            }
                            this.model.UserVerifiedBy = "Loyaltylink_EditProfile";
                            userdata = data;
                            this.setUserDetails(userdata);
                        });
                }
            },
            error => {
                console.log("getting error" + error);
            }
        );
    }
    onLinkClick($event: any) {
        console.log("onLinkClick");
        if ($event.index === 1) {
            this.getUserDocumentsList();
            // this.getcountrylistfromservice();
            this.editProfileTabImage = "./assets/images/p_gray_icon.png";
            this.editProfileDocumentTabImage = "./assets/images/doc_green_icon.png";
        } else {
            this.editProfileTabImage = "./assets/images/p_icon.png";
            this.editProfileDocumentTabImage = "./assets/images/doc_icon.png";
            this.userDetails();
        }
    }

    ngOnInit() {
        //  AppSettings.HeaderText = "EditProfile";
        //   this.initialzecollection()
        this.threatMetrixService.Init();
        this.defaultDate = new Date(
            moment()
                .subtract(100, "years")
                .format("MM/DD/YYYY")
        ); //

        this.yearRange =
            new Date().getFullYear() - 100 + ":" + (new Date().getFullYear() - 18);
    }
    // getcountrylistfromservice() {
    //   if (this.model.country == '') {
    //     this.filterstates = this.countrycollection.filter(item => item.CountryCode == this.model.country)[0].states;
    //   }
    //   if (this.model.state == '') {
    //     this.filterCities = this.filterstates.filter(item => item.StateCode == this.model.state)[0].Cities;
    //     this.cityCollection = this.filterstates.filter(item => item.StateCode == this.model.state)[0].CityList;
    //   }
    // }

    // onChange(contryCode) {
    //   const mobilePre = this.countrycollection.filter(function(country) {
    //     return country.CountryCode == contryCode;
    //   });

    //   if (mobilePre.length > 0) {
    //     this.model.mobilePrefix = Number(mobilePre[0].CountryDialingCode);
    //   } else {
    //     this.model.mobilePrefix = Number(this.mobilePre);
    //   }
    //   this.model.mobilePrefix = 1; // As off now this will only support USA
    //   //Logic of state
    //   if (this.countrycollection.length > 0) {
    //     try {
    //       this.filterstates = this.countrycollection.filter(item => item.CountryCode == this.model.country)[0].states;
    //     } catch (ex) {
    //       console.log(ex);
    //     }
    //   }
    //   if (this.filterstates.length > 0 && this.model.state.length > 0) {
    //     try {
    //       this.filterCities = this.filterstates.filter(item => item.StateCode == this.model.state)[0].Cities;
    //       this.cityCollection = this.filterstates.filter(item => item.StateCode == this.model.state)[0].CityList;
    //     } catch (ex) {
    //       console.log(ex);
    //     }
    //   }
    // }

    openCountryBox() {
        let self = this;
        let modalData: any = {};
        modalData.Title = this.translate
            .instant("CountryPreference_titleLogin")
            .toString();
        modalData.Message = this.translate
            .instant("CountryPreference_descLogin")
            .toString(); //'Please select your Country of preference from the list below:';
        return this.modal
            .open(countrylist, overlayConfigFactory({ modalData }, BSModalContext))
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.next.CountryCode == undefined) {
                    } else {
                        self.model.countryPreference = modalData.next.CountryCode;
                    }
                });
            });
    }

    openStateBox() {
        let self = this;
        let modalData: any = {};
        modalData.CountryCode = this.model.country;
        modalData.StateCollection = this.filterstates;
        return this.modal
            .open(
                StatelistComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.next.StateCode == undefined) {
                    } else {
                        self.model.state = modalData.next.StateCode;
                        self.ddlStateOnChange(modalData.next.StateCode);
                    }
                });
            });
    }

    openCityBox() {
        let self = this;
        let modalData: any = {};
        let citySettings = {
            showSearchButton: false,
            geoTypes: ["(cities)"],
            geoCountryRestriction: ["us"],
            inputPlaceholderText: this.translate.instant("Common_lblSearchFromGoogle")
        };
        modalData.userSettings = citySettings;
        return this.modal
            .open(
                GoogleAutocompleteComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.addressData == undefined) {
                    } else {
                        // self.model.city = modalData.next.City;
                        let addressData = modalData.addressData;
                        self.model.city = self.utilserv.getObjectText(addressData.city);
                        self.model.state = self.utilserv.getObjectText(
                            addressData.stateCode
                        );
                        self.model.stateName = self.utilserv.getObjectText(
                            addressData.stateName
                        );
                        self.model.zipcode =
                            self.utilserv.getObjectText(addressData.zipcode) != ""
                                ? self.utilserv.getObjectText(addressData.zipcode)
                                : self.model.zipcode;
                        // self.searchForBranch();
                    }
                });
            });
    }

    getUserDetailsAfterSubmit() {
        this.utilserv.busy = this.auth.getUserDetail().subscribe(
            data => {
                const resJSON = data;
                if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                    this.model = this.auth.setUserDetails(resJSON);
                    sessionStorage.UserData = this.utilserv.AESEncrypt(JSON.stringify(resJSON));
                }
            },
            error => {
                console.log("getting error" + error);
            }
        );
    }

    openAddressBox() {
        let self = this;
        let modalData: any = {};
        let addressSettings: any = {
            showSearchButton: false,
            geoCountryRestriction: ["us"],
            inputPlaceholderText: this.translate.instant(
                "Common_lblSearchFromGoogle"
            ),
            geoTypes: ["establishment", "address", "geocode"]
        };
        modalData.userSettings = addressSettings;
        return this.modal
            .open(
                GoogleAutocompleteComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.addressData == undefined) {
                    } else {
                        let addressData = modalData.addressData;
                        self.model.address =
                            self.utilserv.getObjectText(addressData.address1) +
                            " " +
                            self.utilserv.getObjectText(addressData.address2);
                        self.model.city = self.utilserv.getObjectText(addressData.city);
                        self.model.state = self.utilserv.getObjectText(
                            addressData.stateCode
                        );
                        self.model.stateName = self.utilserv.getObjectText(
                            addressData.stateName
                        );
                        self.model.zipcode =
                            self.utilserv.getObjectText(addressData.zipcode) != ""
                                ? self.utilserv.getObjectText(addressData.zipcode)
                                : self.model.zipcode;
                    }
                });
            });
    }

    ddlStateOnChange(stateCode) {
        this.model.city = "";
        if (stateCode == "") {
            this.filterCities = [];
            return;
        }
        this.filterCities = this.filterstates.filter(function (state) {
            return state.StateCode === stateCode;
        })[0].Cities;
        this.cityCollection = this.filterstates.filter(
            item => item.StateCode == stateCode
        )[0].CityList;
        if (this.filterCities != null) {
            // this.model.city = this.filterCities[0];
        }
    }

    // onStateChange(statecode) {
    //   if (this.countrycollection.length > 0) {
    //     this.filterstates = this.countrycollection.filter(item => item.CountryCode == this.model.country)[0].states;
    //   }
    //   if (this.filterstates.length > 0 && statecode != '') {
    //     this.filterCities = this.filterstates.filter(item => item.StateCode == statecode)[0].Cities;
    //   } else {
    //     this.filterCities = null;
    //   }
    // }

    // register() {
    //   this.loading = true;
    //   try {
    //     this.model.dob = moment(this.model.dob).format('L');
    //   } catch (ex) {
    //     console.log(ex);
    //   }

    //   this.utilserv.busy = this.userService.editrUser(this.model).subscribe(data => {
    //     const resJSON = data;
    //     this.model.UserID = resJSON.Envelope.Body.CustomerInfoResponse.UserID;
    //     if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
    //       this.alertService.openErrorAlert('Edit Profile', resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
    //     } else {
    //       this.alertService.openErrorAlert('Edit Profile', resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
    //     }

    //     this.loading = false;
    //   });
    // }

    register() {

        this.modal.overlay.defaultViewContainer = this.vcRef;
        try {
            if (this.model.dob == null) {
                this.model.dob = "";
            }
            if (this.model.dob != "") {
                this.model.dob = moment(this.model.dob).format("L");
            }
        } catch (ex) {
            console.log(ex);
        }
        if (this.existinSSNNumber.length > 0 && this.model.taxID.length <= 0) {
            this.alertService.openErrorAlert(
                this.translate.instant("Common_lblInfo"),
                this.translate.instant("Common_lblIDNum")
            );
            return;
        }
        if (this.validateLocaTXNID(this.model.taxID) == true) {
            this.alertService.openErrorAlert(
                this.translate.instant("Common_lblInfo"),
                this.translate.instant("Common_lblIDNum")
            );
            return;
        }
        if (
            this.model.taxID != "" &&
            this.validateTXNID(this.model.taxID) !== true
        ) {
            this.alertService.openErrorAlert(
                this.translate.instant("Common_lblInfo"),
                this.translate.instant("Common_lblIDNum")
            );
            return;
        }

        this.saveEditUser();

    }

    saveEditUser() {

        try {

            this.model.occupation = this.OccupationNameObj ? this.OccupationNameObj.key : "";

            this.saveDocModel.DocumentNumber = this.model.taxID;
            this.userProfileTMNIovation = new UserProfileTMNIovation();
            this.userProfileTMNIovation.deviceProfile.SessionID =
                localStorage.sessionId;
            this.userProfileTMNIovation.deviceProfile.IovationBlackBoxKey =
                sessionStorage.iovationBBKey;
            this.userProfileTMNIovation.eventType =
                enumEventype[enumEventype.Edit_Profile];
            this.userProfileTMNIovation.userProfile = this.model;

            if (!this.fraudDetectionPromise) {

                this.fraudDetectionPromise = new Promise((resolve, reject) => {

                    this.threatMetrixService.Profile().then(sessionId => {
                        this.userProfileTMNIovation.deviceProfile.SessionID = sessionId;
                        this.utilserv.busy = this.auth.profileTMnIovation(this.userProfileTMNIovation).subscribe(data => resolve(data));
                    });
                });
            }

            this.fraudDetectionPromise.then(data => {
                this.utilserv.busy = this.userService.editrUser(this.model).subscribe(
                    data => {
                        const resJSON = data;
                        this.modal.overlay.defaultViewContainer = this.vcRef;
                        this.model.UserID = resJSON.Envelope.Body.CustomerInfoResponse.UserID;
                        if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == 20001) {
                            return false;
                        } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == 8016) {
                            this.alertService.openErrorAlert(this.translate.instant("Common_lblInfo"), this.translate.instant("Common_InvalidPhoneNumber"));
                        }
                        else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == -10000) {
                            this.alertService.openErrorAlert(this.translate.instant("Common_lblInfo"), this.translate.instant("Message_errorMessage"));
                        } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS || resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.userProfileUpdated) {
                            if (this.model.UserVerifiedBy == "Loyaltylink_EditProfile") {
                                let modelData: any = {};
                                modelData.IsBeingLinked = "true";
                                modelData.loyaltyCardNumber = this.model.loyaltyCardNumber;
                                this.userStateService.setLoyaltyUserDetailData(modelData);
                            }
                            // Check Mobile Number in Case if mobile number chnaged call ssn from close dialoiuge
                            if (this.existingMobileNumber != this.model.mobile) {
                                this.getUserDetailsAfterSubmit()
                                this.userStateService.setcurrentUserDetailData(this.model);
                                this.verifyMobileNumberChange(resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
                            } else {
                                if (this.model.taxID != "" && this.existinSSNNumber != this.model.taxID) {
                                    this.saveSSN(resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
                                } else {
                                    this.getUserDetailsAfterSubmit()
                                    this.userStateService.setcurrentUserDetailData(this.model);
                                    this.alertService.openErrorAlert(this.translate.instant("Common_lblInfo"), this.translate.instant("MyProfile_lblSuccessUpdate"));
                                }
                            }
                        } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.loylty_timeout) {
                            const _self = this;
                            const modalData: any = {};
                            modalData.Title = _self.translate.instant("Common_lblOops");
                            modalData.Message = resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage;
                            modalData.Action = _self.translate.instant("Common_lblContinue");
                            this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
                                obj.onDestroy.subscribe(data => {
                                    // clear loyalty scanned user data
                                    _self.loyallog.setEditUserData(null);
                                    _self.formObj.resetForm();
                                    _self.userDetails();
                                });
                            });
                        } else {
                            // First Opp Edit profile failed
                            this.alertService.openErrorAlert(this.translate.instant("Common_lblOops"), resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
                        }

                        // }
                    },
                    error => {
                        console.log("Error while saving user edit profile" + error);
                    }
                );
            });
        } catch (ex) {
            console.log("Error while saving user edit profile");
        }
    }
    saveSSN(statusMessage) {
        // SSN ID Save

        this.utilserv.busy = this.userdoc.saveuserdocument(this.saveDocModel).subscribe(documentdata => {
            this.getUserDetailsAfterSubmit()
            this.userStateService.setcurrentUserDetailData(this.model);
            if (documentdata.Envelope.Body.DocumentInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                this.alertService.openErrorAlert(this.translate.instant("Common_lblInfo"), this.translate.instant("MyProfile_lblSuccessUpdate"));
                // User Profile Updated Succesfully with SSN ID
                this.existinSSNNumber = this.model.taxID;
            } else if (documentdata.Envelope.Body.DocumentInfoResponse.StatusCode == enumStatusCodeList.docAlreadyUploaded) {
                this.alertService.openErrorAlert(this.translate.instant("Common_lblInfo"), this.translate.instant("Message_docAlreadyUploaded"));
            } else {
                // Only Profile Updated as tax ID is not valid, client validation failed
                this.alertService.openErrorAlert(this.translate.instant("Common_lblOops"), this.translate.instant("Message_SSNFailed"));
            }
        });
    }
    verifyMobileNumberChange(statusMessage) {
        console.log("verifyMobileNumberChange user edit profile.component.ts")
        // If change in mobile number send otp to user for verify
        const _self = this;
        const editproofilemodalData: any = {};
        editproofilemodalData.Title = this.translate
            .instant("Common_lblConfirmation")
            .toString();
        editproofilemodalData.Message = this.translate.instant(
            "OTPConfirmPopup_desc"
        );

        editproofilemodalData.watermark = this.translate.instant(
            "OTPConfirmPopup_inputOTP"
        );
        editproofilemodalData.mobileNumber = this.model.mobile;
        editproofilemodalData.UserID = this.model.UserID;

        return this.modal
            .open(
                EditProfileMobileOTPComponent,
                overlayConfigFactory({ editproofilemodalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(dataMobile => {
                    console.log("Observer got a next value: " + dataMobile);
                    if (editproofilemodalData.isMobileUpdated == "yes") {
                        if (
                            _self.model.taxID != "" &&
                            _self.existinSSNNumber != _self.model.taxID
                        ) {

                            _self.saveSSN(statusMessage);
                        } else {
                            const modalData: any = {};
                            modalData.Title = _self.translate.instant("Common_lblInfo");
                            modalData.Message = _self.translate.instant(
                                "MyProfile_lblSuccessUpdate"
                            );

                            _self.modal.overlay.defaultViewContainer = _self.vcRef;
                            _self.modal.open(
                                ErrorPopupComponent,
                                overlayConfigFactory({ modalData }, BSModalContext)
                            );
                            // _self.alertService.openErrorAlert(_self.translate.instant('Common_lblInfo'), _self.translate.instant('MyProfile_lblSuccessUpdate'));
                        }
                    }
                });
            });
    }
    _handleReaderLoaded() {
        try {
            const _self = this;

            _self.utilserv.busy = this.userService
                .editrUserupoloadImage(this.model)
                .subscribe(data => {
                    const resJSON = data;

                    if (
                        resJSON.Envelope.Body.UploadImageResponse.StatusCode ==
                        enumStatusCodeList.SUCCESS
                    ) {
                        // no use
                        // _self.utilserv.busy = this.auth.getUserDetail().subscribe(userDetails => {
                        //   if (userDetails.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
                        //     this.auth.setUserDetails(userDetails);
                        //     sessionStorage.UserData = this.utilserv.AESEncrypt(JSON.stringify(userDetails));
                        //   }
                        // });
                    } else {
                        _self.alertService.error(
                            resJSON.Envelope.Body.UploadImageResponse.StatusMessage
                        );
                    }
                });
        } catch (ex) {
            console.log("Error While Uploading File-Edit Profile" + ex);
        }
    }

    loadDocImage(profileImage) {

        if (profileImage == undefined || profileImage == "") {
            return false;
        }
        // const self = this;
        // self.profileimageUploader.imageThumbnail = AppSettings.BASE_URL + profileImage;
        const self = this;
        if (profileImage != "") {
            this.utilserv.busy = this.utilserv.getIceImage(profileImage).subscribe(
                res => {
                    const urlCreator = window.URL;
                    urlCreator.createObjectURL(res);
                    // self.profileimageUploader.loadAndResize(imageUrl);
                    let arrayBuffer;
                    const fileReader = new FileReader();
                    fileReader.onload = function () {
                        arrayBuffer = this.result;
                        const uarr = new Uint8Array(arrayBuffer);
                        const strings = [],
                            chunksize = 0xffff;
                        const len = uarr.length;
                        // There is a maximum stack size. We cannot call String.fromCharCode with as many arguments as we want
                        for (let i = 0; i * chunksize < len; i++) {
                            strings.push(
                                String.fromCharCode.apply(
                                    null,
                                    uarr.subarray(i * chunksize, (i + 1) * chunksize)
                                )
                            );
                        }
                        self.profileimageData.ImageData = btoa(strings.join(""));
                        self.profileimageUploader.imageThumbnail =
                            "data:image/gif;base64," + self.profileimageData.ImageData;
                    };
                    fileReader.readAsArrayBuffer(res);
                },
                error => {
                    console.log("Unable to fetch Store Image" + error);
                }
            );
        }
    }
    readUrl(event) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: any) => {
                this.url = event.target.result;
                this.model.UserProfileImageBase64 = this.url.split(",")[1];
                this._handleReaderLoaded();
            };

            reader.readAsDataURL(event.target.files[0]);
        }
        // this.handleFileSelect(event);
    }
    // For opening Loyalty Card Verification screen
    OpenEditForgotPassword() {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal.open(
            ResetPasswordEditProfileComponent,
            overlayConfigFactory({}, BSModalContext)
        );
    }

    openLoyaltyCardLogin() {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        const modalData: any = {};
        modalData.isLoggedIn = true;
        return this.modal.open(
            LoyaltyLoginComponent,
            overlayConfigFactory({ modalData }, BSModalContext)
        );
    }

    getUserDocumentsList() {
        this.utilserv.busy = this.userService.getUserDocumets().subscribe(data => {
            const resJSON = data;
            if (
                resJSON.Envelope.Body.DocumentInfoResponse.StatusCode ==
                enumStatusCodeList.SUCCESS
            ) {
                this.docUploadinfo = this.userdoc.populateDocumentModelUserEDit(
                    resJSON
                );
                this.documentList = this.utilserv.getArray(
                    resJSON.Envelope.Body.DocumentInfoResponse.Documents.DocumentInfo
                );
            }
        });
    }
    opendocstep2(modalData) {
        const parent = this;
        modalData.Status = false;
        modalData.isProfile = true;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal
            .open(
                uploaddocumtuserprofilestep2,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    console.log("Observer got a next value: " + data);
                    if (modalData.Status == false) {
                        return;
                    }
                    if (modalData.Status == true) {
                        let evt: any = {};
                        evt.index = 1;
                        parent.onLinkClick(evt);
                    } else {
                    }
                });
            });
    }
    uploaddocumtuserprofilestep1() {
        const parent = this;
        const modalData: any = {};
        modalData.DocumentRequired = this.DocumentRequired;
        this.modal.overlay.defaultViewContainer = this.vcRef;
        return this.modal
            .open(
                uploaddocumtuserprofilestep1,
                overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function (obj) {
                obj.onDestroy.subscribe(data => {
                    if (modalData.Status == false) {
                        return;
                    }
                    console.log("Observer got a next value: " + data);
                    if (modalData.Status == true) {
                        parent.opendocstep2(modalData);
                    }
                });
            });
    }
    uploadDocStep2(evt, existingData) {
        const parent = this;
        let target = evt.currentTarget.value;
        let filterDocument: Identificationtype = this.docUploadinfo.filter(
            item => item.DocumentNumber == target
        );
        filterDocument[0].BackImageUrl = this.utilserv.getObjectText(
            existingData.RearImage
        );
        filterDocument[0].FrontImageUrl = this.utilserv.getObjectText(
            existingData.FrontImage
        );
        filterDocument[0].DocumentID = this.utilserv.getObjectText(
            existingData.DocumentID
        );
        filterDocument[0].DocumentNumber = this.utilserv.getObjectText(
            existingData.DocumentNumber
        );
        filterDocument[0].DocumentType = this.utilserv.getObjectText(
            existingData.DocumentType
        );
        filterDocument[0].ExpirationDate = this.utilserv.getObjectText(
            existingData.ExpirationDate
        );
        filterDocument[0].ImageData = this.utilserv.getObjectText(
            existingData.ImageData
        );
        filterDocument[0].ImageType = this.utilserv.getObjectText(
            existingData.ImageType
        );
        filterDocument[0].IsApproved = this.utilserv.getObjectText(
            existingData.IsApproved
        );
        filterDocument[0].IssuedBy = this.utilserv.getObjectText(
            existingData.IssuedBy
        );
        filterDocument[0].IssuerConCode = this.utilserv.getObjectText(
            existingData.IssuerCountryCode
        );
        filterDocument[0].IssuerStateCode = this.utilserv.getObjectText(
            existingData.IssuerStateCode
        );
        filterDocument[0].UploadType = this.utilserv.getObjectText(
            existingData.UploadType
        );
        filterDocument[0].RequiresExpirationDate =
            this.utilserv.getObjectText(existingData.ExpirationDate) == ""
                ? false
                : true;

        let modalData: any = {};
        modalData.docUploadinfo = filterDocument[0];
        modalData.docType = evt.currentTarget.innerText;
        modalData.docUploadinfo.FrontImage =
            filterDocument[0].FrontImageUrl != "" ? true : false;
        parent.opendocstep2(modalData);
    }

    handleResultSelected(result) {
        this.query = result;
    }

    // For Occupency Auto complete
    setOccupation() {
        if (this.model.occupation) {
            let subscription = this.occupency.getOccupancyList(`{"Filter":"` + this.model.occupation + `", "UpdatedTimeStamp": "", "SearchLanguageCode": "en"}`).subscribe(data => {
                if (data.Occupations.length > 0) {
                    this.OccupationNameObj = data.Occupations[0];
                }
                subscription.unsubscribe();
            });
        }
    }

    search(event) {
        let subscription = this.occupency.getOccupancyList(`{"Filter":"` + event.query + `", "UpdatedTimeStamp": ""}`).subscribe(data => {
            this.finalOccuppeancyresults = data.Occupations;
            subscription.unsubscribe();
        });
    }

    // captureId(event: any) {
    //   this.model.occupation = event.key;
    // }

    // initOccupation() {
    //   let enevelop = `{"UpdatedTimeStamp": ""}`;
    //   this.results = [new Occupation('')];
    //   this.utilserv.busy = this.occupency.getOccupancyList(enevelop).subscribe(data => {
    //     if (data.StatusCode == enumStatusCodeList.SUCCESS) {
    //       data.Occupations.forEach(element => {
    //         const occuptionName = element.OccupationNames.filter(item => item.Language == sessionStorage.langCode.toUpperCase());
    //         this.results.push(new Occupation(occuptionName[0].Name));
    //       });
    //     }
    //   });
    // }

    isdocumentRequiredCheck() {
        // some code here
        this.busy = this.sendMoneyService
            .documentRequiredCheck()
            .subscribe(data => {
                // this.initialzecollection();
                if (
                    data.Envelope.Body.DocumentRequiredResponse.StatusCode ==
                    enumStatusCodeList.SUCCESS
                ) {
                    this.DocumentRequired = data.Envelope.Body.DocumentRequiredResponse;
                    if (
                        data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxID ==
                        "true" ||
                        data.Envelope.Body.DocumentRequiredResponse
                            .RequireCustomerTaxIdForUSID == "true" ||
                        data.Envelope.Body.DocumentRequiredResponse.RequireCustomerID ==
                        "true"
                    ) {
                        this.isDocumentRequired = true;
                    } else {
                        this.isDocumentRequired = false;
                    }
                } else {
                    this.isDocumentRequired = false;
                }
            });
    }
    // fancy Image Uploader
    imageUploaderStatusChanged(status: Status) {
        // if (this.profileimageData.fileToUpload == undefined) {
        //   return false;
        // }
        console.log("imageuploaderstatuschanged in edit user profile" + status);
        const self = this;
        if (status === Status.Selected) {
            // this.profileimageData.ImageType = this.profileimageUploader.fileToUpload.type.split('/')[1];
            let arrayBuffer;
            const fileReader = new FileReader();
            fileReader.onload = function () {
                arrayBuffer = this.result;
                // self.imageDataFront.ImageData = btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
                const uarr = new Uint8Array(arrayBuffer);
                const strings = [],
                    chunksize = 0xffff;
                const len = uarr.length;
                // There is a maximum stack size. We cannot call String.fromCharCode with as many arguments as we want
                for (let i = 0; i * chunksize < len; i++) {
                    strings.push(
                        String.fromCharCode.apply(
                            null,
                            uarr.subarray(i * chunksize, (i + 1) * chunksize)
                        )
                    );
                }
                self.utilserv.busy = self.utilserv

                    .jicCompressImage(
                        btoa(strings.join("")),
                        50,
                        self.profileimageUploader.fileToUpload.type, self.profileimageUploader.fileToUpload.size)
                    .subscribe(
                        data => {
                            self.profileimageData.ImageData = data.split(",")[1];
                            self.model.UserProfileImageBase64 =
                                self.profileimageData.ImageData;
                            self._handleReaderLoaded();
                        },
                        error => { }
                    );

                // self.profileimageData.ImageData = btoa(strings.join(''));
                // self.model.UserProfileImageBase64 = self.profileimageData.ImageData;
                // self._handleReaderLoaded();
            };
            if (this.profileimageUploader.fileToUpload != undefined) {
                fileReader.readAsArrayBuffer(this.profileimageUploader.fileToUpload);
            }
        } else {
            this.profileimageData.ImageType = "jpeg";
            this.profileimageData.ImageData = "";
        }
    }
    // Get Document List

    returnTaxMask() {
        let maskPattern = "";
        this.utilserv.busy = this.userdoc
            .getcountrydoucmenttypelistrequest(AppSettings.BaseCountry)
            .subscribe(
                data => {
                    if (data.StatusCode == enumStatusCodeList.SUCCESS) {
                        const list = this.utilserv.getArray(data)[0].Identificationtypes;
                        list.forEach(element => {
                            if (
                                element.IsTaxId == true &&
                                element.IssuerCountryCode == AppSettings.BaseCountry
                            ) {
                                this.taxMaskPattern = this.utilserv.getArray(element.Masks);

                                this.saveDocModel.DocumentID = 0;
                                this.saveDocModel.TypeName = this.utilserv.getObjectText(
                                    element.TypeName
                                );
                                this.saveDocModel.ExpirationDate = null;
                                this.saveDocModel.IsApproved = false;
                                this.saveDocModel.IssuedBy = AppSettings.BaseCountry;
                                this.saveDocModel.IssuerStateCode = null;
                                this.saveDocModel.IssuerConCode = AppSettings.BaseCountry;
                                this.taxMaskPattern.forEach(taxPattern => {
                                    maskPattern += taxPattern.Mask.replace(/-/g, "") + ",";
                                });
                            }
                        });
                    }
                    this.taxMaskPlaceHolder = this.translate.instant(
                        "MyProfile_inputTaxId"
                    );
                    this.taxMaskPlaceHolder += " " + maskPattern.slice(0, -1);

                    // IsTaxId: true, IssuerCountryCode: "US"
                },
                error => {
                    console.log(
                        "Error occured-Edit Profile Get Document List for Tax ID " + error
                    );
                }
            );
    }

    validateTXNID(taxNumber) {
        for (const mask of this.taxMaskPattern) {
            const pat = this.utilserv.getPattern(
                this.utilserv.getObjectText(mask.Prefix),
                mask.Mask,
                this.utilserv.getObjectText(mask.Suffix)
            );
            const regexp = new RegExp(pat);
            if (regexp.test(taxNumber) === true) {
                return true;
                // break;
            }
        }
    }
    validateLocaTXNID(taxNumber) {
        if (this.model.taxID == "" && this.existinSSNNumber != this.model.taxID) {
            return;
        }
        const pat = "^(\\d)(?:(.)\\1*|0?1?2?3?4?5?6?7?8?9?|9?8?7?6?5?4?3?2?1?0?)$";
        const regexp = new RegExp(pat);
        if (regexp.test(taxNumber) === true) {
            return true;
        } else {
            return false;
        }
    }

    ngOnDestroy() {
        if (this.loyallogUnsub != undefined) {
            this.loyallogUnsub.unsubscribe();
        }
        this.loyallog.clearUserData();
    }

    autoCompleteCallback(place: any) {
        let addressData: any = {};
        let componentForm = {
            street_number: "short_name",
            route: "long_name",
            locality: "long_name",
            administrative_area_level_1: "short_name",
            country: "long_name",
            postal_code: "short_name"
        };
        if (place.data == undefined) {
            return false;
        }

        let data = place.data.address_components;
        for (var i = 0; i < data.length; i++) {
            var addressType = data[i].types[0];
            if (componentForm[addressType]) {
                switch (addressType) {
                    case "street_number":
                        addressData.address1 = data[i].long_name;
                        break;
                    case "route":
                        addressData.address2 = data[i].long_name;
                        break;
                    case "locality":
                        addressData.city = data[i].long_name;
                        break;
                    case "administrative_area_level_1":
                        addressData.stateName = data[i].long_name;
                        addressData.stateCode = data[i].short_name;
                        break;
                    case "country":
                        addressData.countryCode = data[i].short_name;
                        addressData.countryName = data[i].long_name;
                        break;
                    case "postal_code":
                        addressData.zipcode = data[i].long_name;
                        break;
                    default:
                        break;
                }
            }
        }
        // this.utilserv.getObjectText(place.data.name) + ', ' + removed from address
        this.model.address =
            this.utilserv.getObjectText(addressData.address1) +
            " " +
            this.utilserv.getObjectText(addressData.address2);
        this.model.city = this.utilserv.getObjectText(addressData.city);
        this.model.state = this.utilserv.getObjectText(addressData.stateCode);
        this.model.stateName = this.utilserv.getObjectText(addressData.stateName);
        this.model.zipcode = this.utilserv.getObjectText(addressData.zipcode);
    }
    ngAfterContentChecked() {
        try {
            const collection = $("div.match-parent p:nth-child(2)");
            collection[0].innerHTML = this.translate.instant(
                "MyProfile_lblProfileUpload"
            );
        } catch (error) { }
    }

    onStateChanged(event) {

        let self = this;

        if (self.model.state) {

            let selectedState = self.stateCollection.find(x => {
                return x.statecode == self.model.state;
            });

            if (selectedState) {
                self.model.stateName = selectedState.name;
            }

        } else {
            self.model.stateName = '';
        }
    }
}

export class Occupation {
    constructor(public Name: string) { }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/user-editprofile.component.ts